import React from "react";
import MainContainer from "../../components/partials/maincontainer";

const ViewDataSystems = () => {
  return (
    <MainContainer>
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Optio quia a
      inventore. Rem sit pariatur ad quia officiis! Voluptas laboriosam quidem
      vero quo asperiores quis cum expedita qui reprehenderit quaerat corrupti
      deserunt enim laudantium sapiente, corporis veritatis impedit ea et sed
      ratione nulla ipsam. Rem voluptates minus placeat non provident ducimus
      voluptate, expedita eum assumenda fugiat, exercitationem dolorum omnis
      delectus ad. Reprehenderit, ad amet odio maxime, excepturi quasi
      voluptatem possimus quaerat tempore quisquam cum est doloribus tenetur
      sunt pariatur temporibus dicta provident iure dolor accusantium?
      Dignissimos praesentium distinctio ut rerum error debitis alias, vel
      accusamus et, eveniet quod provident recusandae iste numquam culpa ratione
      reiciendis quidem nostrum facere aliquam sequi aperiam dolor, in
      asperiores? Placeat necessitatibus omnis autem ipsam eveniet rem
      dignissimos, harum laborum, fuga eligendi illo at tempore, cupiditate
      veniam quasi facilis fugiat doloribus accusantium repellat quisquam
      tenetur maxime recusandae. Itaque soluta omnis corporis quidem quisquam
      sit animi velit similique expedita repellat reprehenderit iusto recusandae
      labore praesentium nam, voluptas ex beatae doloremque consequuntur
      assumenda. Odio dolores ullam architecto itaque maxime excepturi. Illum
      asperiores doloremque assumenda eum. Magni nulla at cupiditate eligendi a
      nam distinctio debitis error quaerat iure possimus quia atque similique
      cumque nisi vitae ratione, recusandae tenetur dolores sequi consequuntur
      accusantium nobis? Aut molestias cum, in quo vel ipsam commodi, temporibus
      voluptates praesentium facilis qui pariatur enim excepturi voluptatibus!
      Nostrum exercitationem aliquam architecto nihil laborum adipisci ab
      officia saepe, ex expedita ut laboriosam cupiditate sequi reprehenderit
      delectus ad! Sunt incidunt itaque provident ut cupiditate ducimus dolores
      corrupti, in ad eum quo, esse magnam, quia eius dicta explicabo voluptas
      est. Sapiente ullam aperiam id. Aut minima doloribus ducimus at sint id
      enim, magnam culpa eos, adipisci ad? Obcaecati amet fuga ratione aut,
      delectus magni at, nemo illum et pariatur vero consequatur quis quisquam
      facere quas asperiores, ut iure accusamus quo. Sit, blanditiis debitis!
      Pariatur minima quibusdam libero sint, est corrupti, fugiat omnis dicta
      sed et illum alias dolorum architecto sit optio maiores. Ipsam sunt
      aspernatur asperiores delectus labore, fuga nihil? Beatae consectetur
      tempore fugiat impedit debitis natus dolore molestiae nemo modi ipsum sunt
      sed pariatur doloremque suscipit eum inventore, ad nihil deleniti
      possimus. Deleniti explicabo reprehenderit incidunt magnam ipsam a et quam
      molestiae quia! Dolorum, omnis placeat. Earum est, corrupti nihil
      aspernatur quis eaque? Veritatis quod fugit quis laboriosam impedit,
      dolore quaerat velit non consectetur, sapiente, possimus sunt molestiae? A
      aliquid expedita fuga accusamus, velit ipsa ex placeat id accusantium,
      repellat asperiores dolor ad qui saepe magni unde repudiandae iusto quas
      dignissimos reiciendis sit? Dolorum eveniet excepturi corrupti itaque
      expedita nobis adipisci nostrum. Quod, vero odit iste, voluptatum
      repellendus minus doloremque culpa suscipit nulla voluptatem accusamus
      facilis? Quisquam necessitatibus vero quos dicta doloremque aperiam ab
      iusto sunt, reprehenderit soluta ullam cupiditate ea distinctio assumenda,
      voluptate perferendis recusandae tempora! Qui dolorem earum quas sed quia
      similique hic reprehenderit quasi repudiandae nobis ab ipsum corporis
      deleniti labore, ex ad libero asperiores unde beatae assumenda adipisci!
      Reprehenderit et aspernatur magnam consequuntur neque debitis, facere
      expedita incidunt illo enim sapiente rem. Vitae, possimus?
    </MainContainer>
  );
};

export default ViewDataSystems;
